module.exports = __webpack_public_path__ + "img/9-18.bc468708.jpg";